import { useQuery } from "@tanstack/react-query";
import classNames from "classnames";
import React from "react";
import { useAppContext } from "../../hooks/useAppContext";
import { useErrorHandling } from "../../hooks/useErrorHandling";

import "./svg-icon.css";

export const SvgIcon = ({
	svgUrl,
	rotated,
	color,
}: {
	svgUrl: string;
	rotated?: boolean;
	color?: string;
}) => {
	const { client, reactQueryNoReloadOptions } = useAppContext();

	const { createErrorHandler } = useErrorHandling();

	const queryResult = useQuery([svgUrl], () => client.getSvgAsync(svgUrl), {
		...reactQueryNoReloadOptions,
		onError: createErrorHandler(),
	});

	const showIconOutline = color && (color === "white" || color === "#ffffff");

	const className = classNames("svg-icon", {
		"svg-icon--rotated": rotated,
		"svg-icon--outline": showIconOutline,
	});

	return queryResult.isSuccess ? (
		<span
			className={className}
			dangerouslySetInnerHTML={{ __html: queryResult.data }}
			style={color ? ({ "--svg-icon--color": color } as React.CSSProperties) : undefined}
		/>
	) : null;
};
